export const toCamelCase = (text: string) => {
    return text.replace(/\s+(\w)/g, (_, letter) => letter.toUpperCase());
};

export interface TextWithLinkParts {
    before: string;
    linkHref: string;
    linkText: string;
    after: string;
}

export const splitTextAroundLink = (text: string): TextWithLinkParts | null => {
    const match = text.match(/^([\s\S]*?)<a[^>]*href="([^"]*)"[^>]*>([\s\S]*?)<\/a>([\s\S]*)$/);
    if (!match) return null;

    const [, before, linkHref, linkText, after] = match;
    return { before, linkHref, linkText, after };
};
